import { createAction } from '@reduxjs/toolkit';
import { IMasterData } from './types';

export const masterDataRequest = createAction<void>('MASTER_DATA/REQUEST');
export const masterDataSuccess = createAction<IMasterData>('MASTER_DATA/SUCCESS');
export const masterDataFail = createAction<Error>('MASTER_DATA/FAIL');
